import config from '../../config/generated.json'

export default function isOutletsGroupByStatus(): boolean {
  return !!config.ui.isOutletsGroupByStatus
}
